{
    "UI_Container_Title": "Vollständige Kontoeinrichtung",
    "UI_Container_Description": "Geben Sie Ihren vollständigen Namen und ein Passwort ein, um die Registrierung abzuschließen.",
    "UI_Name_Placeholder": "Vollständiger Name",
    "UI_Name_Label": "Vollständiger Name",
    "UI_Password_Placeholder": "Passwort",
    "UI_Password_Label": "Passwort",
    "UI_PasswordLengthValidation": "Das Passwort ist zu kurz",
    "UI_PasswordRequiredValidation": "Das Passwort darf nicht leer sein",
    "UI_PasswordStrengthValidation": "Das Passwort ist nicht stark genug (achten Sie darauf, dass es sowohl Groß- und Kleinbuchstaben als auch Zahlen enthält)",
    "UI_Footer_Server_Error": "Server-Fehler",
    "UI_Footer_Submit_Button": "Einreichen",
    "UI_NameRequiredValidation": "Bitte geben Sie Ihren Namen ein",
    "NAME": "UserInvite"
}